import { alpha, decomposeColor } from '@mui/material';
import Color from 'color';

export function desaturate(hex: string, ratio: number) {
  const color = Color(decomposeColor(hex).values);
  return color.desaturate(ratio).hex();
}

type BgBlurProps = {
  blur?: number;
  opacity?: number;
  color?: string;
};

export function bgBlur(props?: BgBlurProps) {
  const color = props?.color || '#000000';
  const blur = props?.blur || 6;
  const opacity = props?.opacity || 0.8;

  return {
    backdropFilter: `blur(${blur}px)`,
    WebkitBackdropFilter: `blur(${blur}px)`,
    backgroundColor: alpha(color, opacity),
  };
}
